{
	"title": "Language management",
	"subtitle": "Activate or deactivate the languages available across the platform. The default language cannot be deactivated.",
	"defaultLanguageHint": "Default language",
	"switchAriaLabel": "Set {{language}} status",
	"status": {
		"active": "Active",
		"inactive": "Inactive"
	},
	"toasts": {
		"activated": "{{language}} has been activated.",
		"deactivated": "{{language}} has been deactivated."
	},
	"errors": {
		"loadFailed": "Failed to load languages. Please try again.",
		"updateFailed": "Failed to update the language. Please try again."
	}
}
